<template>
    <div>
        <br>
        <div class="row">
            <div class="col-md-3">
                <div class="input-group">
                    <span class="input-group-btn">
                        <button type="button" class="btn bg-light-blue btn-sm waves-effect" data-toggle="modal" data-target="#m_tambah_data"><i class="material-icons" title="Tambah Data">add</i></button>
                    </span>
                    <input type="text" class="form-control" style="background: #e4e4e3" placeholder="Cari data" id="caridata" @keyup="cari_data" v-model="cari_value">
                </div>
            </div> 
        </div>
        <div class="table-responsive">
            <table class="table table-bordered" style="width: 100%">
                <thead>
                <tr class="bg-info">
                    <th style="width: 5%">No.</th>
                    <th style="width: 25%">Nilai</th>
                    <th style="width: 15%">#</th>
                </tr>
                </thead>
                <tbody>
                    <tr class="h_isitable" >
                        <td>1.</td>
                        <td>xxx</td>
                        <td class="text-center" >

                        <button class="btn bg-light-green btn-xs waves-effect" title="Edit Data" id="edit_data" data-toggle="modal" data-target="#m_edit_data">
                            <i class="material-icons" >create</i>
                        </button>

                        <button class="btn bg-red btn-xs waves-effect" title="Hapus Data" id="hapus_data">
                            <i class="material-icons" >clear</i>
                        </button>
                        </td>
                    </tr>

                </tbody>
            </table>
        </div>

        <hr>
            <div class="text-center">
                <button @click="btn_prev" type="button" class="btn btn-xs bg-blue waves-effect" id="pref">
                        <i class="material-icons">skip_previous</i>
                </button>

                <span style="font-size: 85%; color: #a5a5a5"><b>1 - 1</b></span>

                <button type="button" class="btn btn-xs bg-blue waves-effect" id="next">
                        <i class="material-icons">skip_next</i>
                </button>
            </div>
        <hr>

        <!-- ============================================================ MODAL ======================================================================== -->


            <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
            <div class="modal fade" id="m_tambah_data" tabindex="-1" role="dialog">
                <div class="modal-dialog modal-lg" role="document">
                    <div class="modal-content">
                        <div class="modal-header bg-light-blue">
                            <h4 class="modal-title" id="largeModalLabel">TAMBAH DATA</h4>
                        </div>
                        <div class="modal-body">

                        <div class="row clearfix">
                            <div class="col-md-2 form-control-label">
                                <label for="kode">Tahun</label>
                            </div>
                            <div class="col-md-10">
                                <div class="form-group">
                                    <div class="form-line">
                                        <input type="text" id="kabupaten" class="form-control" >
                                        <input type="text" id="kabupaten_id" class="form-control" style="display:none" >
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row clearfix">
                            <div class="col-md-2 form-control-label">
                                <label for="kode">Nilai</label>
                            </div>
                            <div class="col-md-10">
                                <div class="form-group">
                                    <div class="form-line">
                                        <input v-model="kecamatan" type="text" class="form-control">
                                    </div>
                                </div>
                            </div>
                        </div>

                        </div>
                        <div class="modal-footer">
                            <button @click="addData" type="button" class="btn btn-info waves-effect">SIMPAN</button>
                            <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                        </div>
                    </div>
                </div>
            </div>
            <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->


            <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
            <div class="modal fade" id="m_edit_data" tabindex="-1" role="dialog">
                <div class="modal-dialog modal-lg" role="document">
                    <div class="modal-content">
                        <div class="modal-header bg-light-green">
                            <h4 class="modal-title" id="largeModalLabel">EDIT DATA</h4>
                        </div>
                        <div class="modal-body">                        

                            <div class="row clearfix">
                            <div class="col-md-2 form-control-label">
                                <label for="kode">Tahun</label>
                            </div>
                            <div class="col-md-10">
                                <div class="form-group">
                                    <div class="form-line">
                                        <input type="text" id="kabupaten" class="form-control" >
                                        <input type="text" id="kabupaten_id" class="form-control" style="display:none" >
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row clearfix">
                            <div class="col-md-2 form-control-label">
                                <label for="kode">Nilai</label>
                            </div>
                            <div class="col-md-10">
                                <div class="form-group">
                                    <div class="form-line">
                                        <input v-model="kecamatan" type="text" class="form-control">
                                    </div>
                                </div>
                            </div>
                        </div>

                        </div>
                        <div class="modal-footer">
                            <button @click="editData" type="button" class="btn btn-success waves-effect">RUBAH</button>
                            <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                        </div>
                    </div>
                </div>
            </div>
            <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->


        <!-- ============================================================ MODAL ======================================================================== -->
    </div>
</template>

<script>
export default {

}
</script>

<style>

</style>
